module.exports = __webpack_public_path__ + "static/media/google-meet-logo.3e8d60e4.png";